import { createContext } from 'react';

import { type GlobalContextType } from '@/context/global/types';

export const GlobalContext = createContext<GlobalContextType>({
  userName: null,
  setUserName: () => {
    /* empty */
  },
});
